"use strict";
import fetch from '@elements/fetch';
import {debounce} from "debounce";
import initModulesInScope from "@elements/init-modules-in-scope";

// Global variables for request tracking and caching
let pendingRequests = new Map(); // Track pending requests per element
let dataCache = new Map(); // Cache loaded data to avoid reloading

export function initInScope ($scope) {
    let url;
    let id;
    let element;

    if(!window.matchMedia("(pointer: coarse)").matches) {
        $scope.find('.js-color-hover__link').on('mouseenter', debounce(function (e) {
            url = $(this).attr('data-color-data');
            id = $(this).attr('data-productid');
            element = $(this);
            let parentId = element.closest('.js-color-hover').attr('data-productid');

            /* load data only if not default product */
            if(id !== parentId) {
                setTimeout(function() {
                    loadColorData(url, element);
                    element.closest('.js-color-hover').addClass('color-changed');
                }, 100);
            }

            /* load default data if new color was already loaded */
            if(id == parentId && element.closest('.js-color-hover').hasClass('color-changed')) {
                setTimeout(function() {
                    loadColorData(url, element);
                    element.closest('.js-color-hover').removeClass('color-changed');
                }, 100);
            }
        }, 150));

        $scope.find('.js-color-hover').on('mouseleave', function (e) {
            url = $(this).attr('data-color-default-data');
            element = $(this);

            if(element.hasClass('color-changed')) {
                /* wait until zoom animation has finished, then reload data */
                setTimeout(function() {
                    loadColorData(url, element);
                    element.removeClass('color-changed');
                }, 100);
            }
        });
    }
}



function loadColorData(url, element) {
    let $this = element;
    let $teaser = $this.closest('.js-color-hover');
    let $image = $this.closest('.js-color-hover').find('.js-color-hover__img');
    let $title = $this.closest('.js-color-hover').find('.js-color-hover__title');
    let $price = $this.closest('.js-color-hover').find('.js-color-hover__price');
    let $sizes = $this.closest('.js-color-hover').find('.js-color-hover__sizes');
    let $btn = $this.closest('.js-color-hover').find('.js-color-hover__href-btn');
    let $link = $this.closest('.js-color-hover').find('.js-color-hover__link');

    // Create unique identifier for this element to track requests and cache data
    let elementId = $teaser[0] ? $teaser[0] : element[0];
    
    // Check if we already have cached data for this URL
    if (dataCache.has(url)) {
        updateElementWithData(dataCache.get(url), $title, $btn, $price, $image, $sizes, $link);
        return;
    }

    // Cancel any pending request for this element
    if (pendingRequests.has(elementId)) {
        pendingRequests.get(elementId).abort();
        pendingRequests.delete(elementId);
    }

    // Start new request and track it
    let pendingRequest = fetch(url, {
        method: 'GET'
    });
    
    pendingRequests.set(elementId, pendingRequest);

    pendingRequest.then((res) => {
        return res.clone().json()
    }).then((res) => {
        // Remove this request from pending requests since it's completed
        pendingRequests.delete(elementId);
        
        if(res.success){
            // Cache the successful response data
            dataCache.set(url, res);
            
            // Update the element with the data
            updateElementWithData(res, $title, $btn, $price, $image, $sizes, $link);
        } else {
            //console.log(res);
        }
    }).catch((error) => {
        // Remove this request from pending requests on error
        pendingRequests.delete(elementId);
        
        // Don't log AbortError as it's intentional when cancelling requests
        if (error.name !== 'AbortError') {
            console.error('Error loading color data:', error);
        }
    });
}

// Helper function to update element with data (either from cache or fresh request)
function updateElementWithData(data, $title, $btn, $price, $image, $sizes, $link) {
    if(data.title){
        $title.html(data.title);
    }
    if(data.maintitle){
        $btn.html(data.maintitle);
    }
    if($price && data.price){
        $price.html(data.price);
    }
    if($image && data.image){
        setTimeout(function() {
            $image.html(data.image);
            initModulesInScope($image);
        }, 100);
    }
    if($sizes && data.sizes){
        $sizes.html(data.sizes);
    }
    if(data.href){
        $btn.attr('href',data.href);
        $link.attr('href',data.href);
    }

    if($sizes.length){initModulesInScope($sizes);}
}
